// extracted by mini-css-extract-plugin
export default {"remove":"ContextMenuItems_remove__CyCZm"};